import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { RouteError } from '@/components/route-error'
import { redirectToAnalytics } from '@/features/reports/legacy-analytics-redirect'

// Moved to /analytics — see legacy-analytics-redirect.
export const Route = createFileRoute('/_dashboard/reports/cash')({
  beforeLoad: redirectToAnalytics,
  pendingComponent: RoutePending,
  errorComponent: RouteError,
})
